import axios from '../config/axiosConfig';

const API_URL = '/authsmash';

const authSmashService = {
  startTest: async (webTargetId, config) => {
    const res = await axios.post(`${API_URL}/start/${webTargetId}`, config);
    return res.data;
  },

  getStatus: async (scenarioId) => {
    const res = await axios.get(`${API_URL}/status/${scenarioId}`);
    return res.data;
  },

  getResults: async (scenarioId) => {
    const res = await axios.get(`${API_URL}/results/${scenarioId}`);
    return res.data;
  },

  getMatrix: async (scenarioId) => {
    const res = await axios.get(`${API_URL}/matrix/${scenarioId}`);
    return res.data;
  },

  // Server-side content search across the scenario's request/response bodies.
  searchBodies: async (scenarioId, q) => {
    const res = await axios.get(`${API_URL}/search/${scenarioId}`, { params: { q } });
    return res.data; // { matches: ["METHOD url", ...] }
  },

  // Enrich an existing run: use the HAR-captured admin responses as the baseline
  // and recompute verdicts (keeps the live-captured test results).
  enrichHarBaseline: async (scenarioId) => {
    const res = await axios.post(`${API_URL}/enrich-har-baseline/${scenarioId}`);
    return res.data;
  },

  // Re-baseline an existing run against any column (profile _id or 'unauth').
  setBaseline: async (scenarioId, referenceId) => {
    const res = await axios.post(`${API_URL}/set-baseline/${scenarioId}`, { referenceId });
    return res.data;
  },

  cancelTest: async (scenarioId) => {
    const res = await axios.post(`${API_URL}/cancel/${scenarioId}`);
    return res.data;
  },

  getScenarios: async (webTargetId) => {
    const res = await axios.get(`${API_URL}/scenarios/${webTargetId}`);
    return res.data;
  },

  deleteScenario: async (scenarioId) => {
    const res = await axios.delete(`${API_URL}/scenario/${scenarioId}`);
    return res.data;
  },

  createBlankScenario: async (webTargetId, config) => {
    const res = await axios.post(`${API_URL}/create-blank/${webTargetId}`, config);
    return res.data;
  },

  // Live AuthSmash Mode
  startLiveSession: async (config) => {
    const res = await axios.post('/live-authsmash/start', config);
    return res.data;
  },

  stopLiveSession: async (sessionId) => {
    const res = await axios.post(`/live-authsmash/stop/${sessionId}`);
    return res.data;
  },

  getLiveStatus: async (sessionId) => {
    const res = await axios.get(`/live-authsmash/status/${sessionId}`);
    return res.data;
  }
};

export const enforcementConfig = {
  enforced: { label: 'Enforced', color: 'green', icon: 'shield-alt' },
  bypassed: { label: 'Bypassed', color: 'red', icon: 'exclamation-triangle' },
  partial: { label: 'Needs Review', color: 'yellow', icon: 'question-circle' },
  error: { label: 'Error', color: 'gray', icon: 'times-circle' }
};

export default authSmashService;
